<template>
  <div id="reports">
    <img
      @click="$emit('closeModal')"
      class="close-icon"
      src="../../assets/icons/close.png"
      alt="Close"
    />
    <h1 class="header-text">
      <span
        >Izvještaj
        <div class="header-text-line"></div>
      </span>
      <div v-if="lastUpdatedAt" class="last-updated-info">
        Zadnji puta ažurirano: {{ lastUpdatedAt }}
      </div>
    </h1>
    <report-single
      v-for="(report, i) in reports"
      :key="i"
      :report="report"
    ></report-single>
    <p v-if="noData" class="text-center">Nema zabilježenih izvještaja.</p>
  </div>
</template>

<script>
import ReportSingle from "./Single";
export default {
  props: ["appointmentId"],
  components: {
    reportSingle: ReportSingle,
  },
  data() {
    return {
      reports: [],
      //In case of reports.lenght == 0 would be true
      noData: false,
    };
  },
  methods: {
    getReports() {
      this.$store.state.services.reportService
        .appointmentReports(this.appointmentId)
        .then((response) => {
          this.reports = response.data;
          if (this.reports.length == 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        });
    },
  },
  watch: {
    appointmentId() {
      this.getReports();
    },
  },
  computed: {
    lastUpdatedAt() {
      return this.$data.reports.length > 0 && this.reports[0].LastUpdated
        ? this.$moment(this.reports[0].LastUpdated).format("DD.MM.YYYY u HH:mm")
        : "";
    },
  },
};
</script>

<style scoped>
#reports {
  background-color: white;
  padding: 25px;
  position: relative;
}
.header-text {
  margin-bottom: 20px;
}
.last-updated-info {
  font-size: 14px;
  margin-top: 10px;
}
</style>
